import React, { useEffect, useState } from 'react'
import { Button, Input, DatePicker, Form, InputNumber, Select, Table, Popconfirm } from 'antd';
import { getItem, createItem, deleteItem } from '../../controller/Control';
import { LuTrash2 } from "react-icons/lu";
import type { FormProps } from 'antd';
import Password from 'antd/es/input/Password';

interface Users {
	user: string;
	pass: string;
	admin: boolean;
	email: string;
}

const Users: React.FC = () => {
    const [ dataUsers, setDataUsers] = useState<Users[]>([])
	const [ dataUsersFilter, setDataUsersFilter] = useState<Users[]>([])
	const [ usersActions, setUsersActions ] = useState({
		view: false,
		add: false,
		edit: false
	})
	const [form] = Form.useForm();
	

	const getData = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/users` || 'localhost:3000', token)
		setDataUsers(data)
	}

	useEffect(() => {
		getData()
	}, [0])

	useEffect(() => {
		getData()
	}, [usersActions])

	const createData = async(values: FormProps) => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const create = await createItem(`${process.env.REACT_APP_API_SERVER}/users` || 'localhost:3000', values, token)
		if(create === 401){
			alert('Error General, o usuario ya creado, intente nuevamente')
		}
		if(create === 409){
			alert('Ya existe un código con el mismo número')
		}
		if(create._id){
			alert('Usuario creado con exito')
			form.resetFields();
			setUsersActions({view: false, add: false, edit: false})
		}
	}

	const handleSubmit = (values: FormProps) => {
		createData(values)
	}

    const deleteUser = async(data: any) => {
        const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const create = await deleteItem(`${process.env.REACT_APP_API_SERVER}/users/${data._id}` || 'localhost:3000', token)
		if(create._id){
			getData()
		}
    }


	const columns = [
		{
			title: 'Usuario',
			dataIndex: 'user',
			key: 'user',
		},
		{
			title: 'E-Mail',
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: 'Roll',
			render: (a: any) => a.admin === true ? 'Administrador' : 'Delegado',
			key: 'admin',
		},
        {
            title: 'Eliminar',
            render: (a: any) => <Popconfirm 
                title="Seguro quiere eliminar este usuario?"
                description="Esta acción no se puede deshacer"
                cancelText="Cancelar"
                onConfirm={() => deleteUser(a)}
            >
                <LuTrash2 size={20} color='red' style={{cursor: 'pointer'}}/>
            </Popconfirm>

        }
	];

	return(
		<div className='px-5'>
			<div className='my-5 flex flex-col md:flex-row'>
				<div>
					{!usersActions.view ?
					<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' onClick={() => setUsersActions({view: true, add: true, edit: false})}>Agregar Usuario</button> : null}
				</div>
			</div>
			<div className='justify-center flex-col items-center patient' style={usersActions.view ? {display: 'flex'} : {display: 'none'}}>
				<h1 className='text-2xl text-text-menu my-5'>{usersActions.add ? 'Agrega un Usuario' : usersActions.edit ? 'Modificar un Usuario' : null}</h1>
				<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
					<Form
						layout='vertical'
						style={{maxWidth: 400}}
						onFinish={handleSubmit}
						form={form}
					>

						<Form.Item label="Usuario" name="user" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="E-Mail" name="email" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Contraseña" name="pass" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input.Password />
						</Form.Item>

						<Form.Item label="Roll" name="admin" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Select 
								defaultValue={''}
								style={{width: 220}}
								options= {[{value: true, label: 'Administrador'}, {value: false, label: 'Delegado'}]}
							/>
						</Form.Item>

                        <Form.Item>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit">
								Agregar
							</button>
							<button className='bg-text-menu ml-2 text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' onClick={() => setUsersActions({view: false, add: false, edit: false})}>
								Cancelar
							</button>
						</Form.Item>
					</Form>
				</div>
			</div>
			<div>
				<Table 
					dataSource={dataUsers} 
					columns={columns}
				/>
			</div>
		</div>
	)

}

export default Users